import { Button } from '@mui/material';
import { useQuizContext, useUserContext } from 'contexts';
import { useQuizFocus } from 'hooks';
import { CSSProperties } from 'react';
import { useParams } from 'react-router-dom';

interface Props {
    backgroundStyles: CSSProperties;
    fontStyles: CSSProperties;
    titleStyles: CSSProperties;
    onShowAnswersClick: () => void;
    onEndQuiz: () => void;
}

export const QuizEndScreen = (props: Props) => {
    const { quiz } = useQuizContext();
    const { eventAlias } = useParams();
    useQuizFocus();
    
    const { isQuizCreatorOrEventAdmin } = useUserContext();
    return (
        <div className="slides-wrapper column" style={props.backgroundStyles}>
            <h2 style={props.titleStyles}>{quiz.name}</h2>
            <div style={props.fontStyles}>
                <p>Thank you for participating :)</p>
            </div>
            {isQuizCreatorOrEventAdmin(quiz.id!, eventAlias) && (
                <>
                    <br />
                    <Button variant="contained" sx={{maxWidth: '200px'}} onClick={props.onShowAnswersClick}>
                        Show answers
                    </Button>
                </>
            )}
            <br />
            <Button variant="contained" sx={{maxWidth: '200px'}} onClick={props.onEndQuiz}>
                End Quiz
            </Button>
        </div>
    );
};
